







// @ts-nocheck
import Vue from 'vue';
import { Answer, IState } from '../store/state';

interface RateButtonProps {
    answer: Answer;
}

interface RateButtonComputed {
    type: any;
	text: string;
	activeClass: any;
	disabled: boolean;
}

interface RateButtonMethods {
	onClick(): void;
}

export default Vue.extend<{}, RateButtonMethods, RateButtonComputed, RateButtonProps>({
    props: {
        answer: String as () => Answer,
    },
    computed: {
        type(){
            return {
                'kb-page-rating-button--yes': this.answer === 'Y',
                'kb-page-rating-button--no': this.answer === 'N'
            }
		},
		disabled() {
			return (this.$store.state as IState).answer !== 'NONE'
		},
		activeClass() {
			return {
				'kb-page-rating-button--active': this.answer === (this.$store.state as IState).answer,
				'kb-page-rating-button--deactive': (this.$store.state as IState).answer !== 'NONE' && this.answer !== (this.$store.state as IState).answer
			}
		},
        text() {
            if(this.answer === 'Y') {
                return (this.$store.state as IState).strings.yes.button;
            } else if(this.answer === 'N') {
                return (this.$store.state as IState).strings.no.button;
            }
            return '';
        }
	},
	methods: {
		onClick() {
			if(!this.disabled) {
				this.$emit('click')
			}
		}
	}
})
